import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login'
import Companies from './views/Companies'
import Company from './views/Company'
import Dictionaries from './views/Dictionaries'
import Jobs from './views/Jobs'
import Job from './views/Job'
import LineItemView from './views/line-item/LineItemView'
import LineItemEdit from './views/line-item/LineItemEdit'
import YBLineItemView from './views/yb-line-item/YBLineItemView'
import YBLineItemEdit from './views/yb-line-item/YBLineItemEdit'
import JobView from './views/job/JobView'
import ContainerView from './views/container/ContainerView'
import ContainerEdit from './views/container/ContainerEdit'
import YBContainerView from './views/yb-container/YBContainerView'
import YBContainerEdit from './views/yb-container/YBContainerEdit'
import Containers from './views/Containers'
import Container from './views/Container'
import YellowBuckets from './views/YellowBuckets'
import YellowBucket from './views/YellowBucket'
import Registrations from './views/Registrations'
import Registration from './views/Registration'
import LineItems from './views/LineItems'
import YBLineItems from './views/YBLineItems'
import LineItem from './views/LineItem'
import YBLineItem from './views/YBLineItem'
import NotFound from './views/NotFound'
import Reports from './views/Reports'

import store from './store'
import Cookies from 'js-cookie'

Vue.use(Cookies);
Vue.use(Router);

let router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		/*{
			path: '/test',
			name: 'test',
			component: MoveYellowBucketList,
			meta: {
				authorized: true
			}
		}
		{
			path: '/parent',
			name: 'parent',
			component: Parent
		},*/
		{
			path: '/',
			name: 'login',
			component: Login
		},
		{
			path: '/dictionaries',
			name: 'dictionaries',
			component: Dictionaries,
			meta: {
				title: 'NDC Dictionary',
				authorized: true
			}
		},
		{
			path: '/companies',
			name: 'companies',
			component: Companies,
			meta: {
				title: 'Companies',
				authorized: true
			}
		},
		{
			path: '/company/:id',
			name: 'company',
			component: Company,
			meta: {
				authorized: true
			}
		},
		{
			path: '/jobs',
			name: 'jobs',
			component: Jobs
		},
		{
			path: '/job/:id',
			component: Job,
			children: [
				{
					name: 'job-view',
					path: '',
					component: JobView,
					meta: {
						authorized: true
					}
				}/*,
				{
					name: 'job-edit',
					path: 'edit',
					component: JobEdit,
					meta: {
						authorized: true
					}
				}*/
			]
		},
		{
			path: '/containers',
			name: 'containers',
			component: Containers
		},
		{
			path: '/container/:id',
			component: Container,
			children: [
				{
					name: 'container-view',
					path: '',
					component: ContainerView,
					meta: {
						authorized: true
					}
				},
				{
					name: 'container-edit',
					path: 'edit',
					component: ContainerEdit,
					meta: {
						authorized: true
					}
				}
			]
		},
		{
			path: '/yb-container/:id',
			component: YellowBucket,
			children: [
				{
					name: 'yb-container-view',
					path: '',
					component: YBContainerView,
					meta: {
						authorized: true
					}
				},
				{
					name: 'yb-container-edit',
					path: 'edit',
					component: YBContainerEdit,
					meta: {
						authorized: true
					}
				}
			]
		},
		{
			path: '/yb-containers',
			name: 'yb-containers',
			component: YellowBuckets,
			meta: {
				title: 'Yellow Bucket Containers',
				authorized: true
			}
		},
		{
			path: '/registration/:id',
			name: 'registration',
			component: Registration,
			meta: {
				authorized: true
			}
		},
		{
			path: '/registrations',
			name: 'registrations',
			component: Registrations,
			meta: {
				authorized: true
			}
		},
		{
			path: '/line-items',
			name: 'line-items',
			component: LineItems,
			meta: {
				title: 'Line Items',
				authorized: true
			}
		},
		{
			path: '/yb-line-items',
			name: 'yb-line-items',
			component: YBLineItems,
			meta: {
				title: 'Yellow Bucket Line Items',
				authorized: true
			}
		},
		{
			path: '/line-item/:id',
			component: LineItem,
			children: [
				{
					name: 'line-item-view',
					path: '',
					component: LineItemView,
					meta: {
						authorized: true
					}
				},
				{
					name: 'line-item-edit',
					path: 'edit',
					component: LineItemEdit,
					meta: {
						authorized: true
					}
				}
			]
		},
		{
			path: '/yb-line-item/:id',
			component: YBLineItem,
			children: [
				{
					name: 'yb-line-item-view',
					path: '',
					component: YBLineItemView,
					meta: {
						authorized: true
					}
				},
				{
					name: 'yb-line-item-edit',
					path: 'edit',
					component: YBLineItemEdit,
					meta: {
						authorized: true
					}
				}
			]
		},
		{
			path: '/reports',
			name: 'reports',
			component: Reports,
			meta: {
				title: 'Reports',
				authorized: true
			}
		},
		{
			path: '/not-found',
			name: 'not-found',
			component: NotFound
		}

	]
});
router.beforeEach((to, from, next) => {
	let token = localStorage.getItem('token')
	if (to.meta.authorized && !token) {
		let message = 'You must be logged-in to access this resource'
		console.log(message);
		store.dispatch('push_error', {
			message: message,
			type: 'WARNING'
		}).then(() => {
			store.dispatch('set_next_route', to.path)
				.then(() => {
					next('/')
				})
		})
	} else {
		next()
	}
});
export default router
